import {useRef} from "react";

const useScroll = () => {
    const ref = useRef(null);
    const scroll = () => ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });

    return [ref, scroll];
};

export default useScroll;